<template>
    <router-view name="router_wrapper_auth"></router-view>
</template>

<script>
    export default {
        name: "Auth"
    }
</script>

